module.exports = __webpack_public_path__ + "img/detect-video.06afe836.png";